// extracted by extract-css-chunks-webpack-plugin
module.exports = {"select":"_37A1j9"};